export default __webpack_public_path__ + "static/flavor-mint-0a440b49784d51c8740d6451ab7bb70d.svg";